import React from 'react';
import Page from '../components/Page';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Label,
  Row,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Form,
  FormFeedback,
  FormGroup,
  FormText,
  Input,
} from 'reactstrap';
import axios from '../utils/posAxios';
import StorageService from '../services/StorageService';
import {
  MdCameraAlt,
  MdFace,
  MdDone,
  MdClear,
  MdCreate,
  MdAdd,
} from 'react-icons/md';
import { BsPlusSquareFill } from 'react-icons/bs';
import NotificationSystem from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants';
import { Redirect } from 'react-router';
import classnames from 'classnames';
import PosStoreForm from '../components/PosStoreForm';
import PosUserForm from '../components/PosUserForm';
import { getProfile, getProfile_v2 } from '../utils/dropdownlist';
import { getUser, getUser_v2 } from '../utils/dropdownlist';
import { IconContext } from 'react-icons/lib';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';

class PosStoreTable extends React.Component {
  _isMounted = true;
  comp = StorageService.getSession('selected_org');
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      Role: this.comp.Role,
      modal: false,
      userModal: false,
      confirmModal: false,
      isEdit: false,
      storeList: [],
      filterList: [],
      fullStoreList: [],
      sortKey: '',
      roleList: [],
      redirect: false,
      selectedStoreId: '',
      store_code: '',
      store_name: '',
      store_location: '',
      remarks: '',
      company_id: '',
      timezone: '+8:00',
      admin_email: '',
      report_time: '',
      userList: [],
      user_id: '',
      name: '',
      email: '',
      profileId: '',
      duplicateId: false,
    };
  }

  componentDidMount() {
    const user = StorageService.getSession('user_info');

    this.getUserStore();
    this.getUser();
    this.getProfile();
  }
  componentWillUnmount() {
    this._isMounted = false;
  }

  IDHandler = event => {
    const { name, value } = event.target;

    let duplicateId = this.state.userList.some(x => x.user_id === value);
    console.log(duplicateId);
    this.setState({
      [name]: value,
      duplicateId: duplicateId,
    });
  };

  toggle = (action, id) => () => {
    if (!this.state.isLoading) {
      if (this.state.userList.length > 0) {
        this.setState({
          modal: !this.state.modal,
          isEdit:
            id != undefined || (id != null && action == 'EDIT') ? true : false,
          selectedStoreId:
            id != undefined || (id != null && action == 'EDIT') ? id : '',
        });
      } else {
        this.setState({
          userModal: !this.state.userModal,
        });
      }
    }
  };

  toggleConfirmModal = (name, id) => () => {
    return this.setState({
      confirmModal: !this.state.confirmModal,
      selectedData: name,
      selectedStoreId: id,
    });
  };

  closeModal = (title, message, level, reload) => {
    this.notificationSystem.addNotification({
      title: title,
      message: message,
      level: level,
      position: 'br',
      autoDismiss: 2,
      dismissible: 'click',
    });

    this.setState({
      modal: false,
    });

    if (reload) {
      window.location.reload();
    } else {
      this.getUserStore();
    }
  };

  changeHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  sortHandler = e => {
    let { value } = e.target;
    this.setState({
      sortKey: value,
    });
    const { storeList, sortKey } = this.state;
    if (value.length) {
      console.log(value);
      let item = storeList.filter(x =>
        JSON.stringify(x).toLowerCase().includes(value.toLowerCase()),
      );
      console.log(item);
      this.setState({ filterList: item });
    } else {
      this.setState({ filterList: storeList });
    }
  };

  delete = () => {
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_UNITY_API2_URL;

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.selectedStoreId,
      delete_by: user.email,
    };

    axios
      .post(url + ':3001/v1/store/delete', data)
      .then(response => {
        const result = response.data;
        if (result.error == true) {
          this.notificationSystem.addNotification({
            title: <MdClear />,
            message: result.message,
            level: 'error',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          });
          return;
        }

        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'Store deleted successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        });
        this.setState({ confirmModal: false });
        this.getUserStore();
      })
      .catch(error => {
        alert(error);
      });
  };

  getUserStore = () => {
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_API_URL;
    const data = {
      session_key: user.session_key,
      CompanyID: comp.CompanyID,
      ProfileID: user.userId,
    };

    axios
      .post(url + ':3000/v1/user/getContentAccess', data)
      .then(response => {
        const result = response.data;
        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        StorageService.setSession('user_access', result.data);
        this.getStoreList();
      })
      .catch(error => {
        alert(error);
      });
  };

  getStoreList = () => {
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const access = StorageService.getSession('user_access');

    // console.log(access);
    const url = process.env.REACT_APP_UNITY_API2_URL;
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    };

    axios
      .post(url + ':3001/v1/store', data)
      .then(response => {
        const result = response.data;
        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        if (this._isMounted) {
          let storeList = [];

          for (let i of access.store) {
            for (let j of result.data) {
              if (j.store_id === i.store_id) {
                if (
                  i.role == 'Admin' ||
                  i.role == 'Supervisor' ||
                  i.role == 'Financial' ||
                  i.role == 'Manager' ||
                  i.role == 'Superuser'
                ) {
                  storeList.push(j);
                }
              }
            }
          }
          this.setState({
            storeList: storeList,
            filterList: storeList,
            fullStoreList: result.data,
            isLoading: false,
          });
        }
      })
      .catch(error => {
        alert(error);
      });
  };

  getUser = () => {
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_UNITY_API2_URL;
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    };

    axios
      .post(url + ':3000/v1/users', data)
      .then(response => {
        const result = response.data;
        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        if (this._isMounted) {
          this.setState({
            isLoading: false,
            userList: result.data,
          });
        }
      })
      .catch(error => {
        alert(error);
      });
  };

  getProfile = () => {
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_UNITY_API2_URL;
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    };

    axios
      .post(url + ':3000/v1/user/profile', data)
      .then(response => {
        const result = response.data;
        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        if (this._isMounted) {
          this.setState({
            roleList: result.data,
          });
        }
      })
      .catch(error => {
        alert(error);
      });
  };

  // getUser() {
  //   getUser_v2()
  //     .then(result => {
  //       if (this._isMounted) {
  //         if (result.error == true && result.message != 'Success') {
  //           alert(result.message);
  //           return;
  //         }
  //         this.setState({
  //           isLoading: false,
  //           userList: result.data.data,
  //         });
  //       }
  //     })
  //     .catch(error => {
  //       alert(error);
  //     });
  // }

  addUser = e => {
    e.preventDefault();
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_UNITY_API2_URL;
    const comp = StorageService.getSession('selected_org');
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      email: this.state.email,
      user_id: this.state.user_id,
      user_name: this.state.name,
      profile_id: this.state.profileId,
      company_id: comp.CompanyID,
      company_name: comp.CompanyName,
      created_by: user.email,
    };

    axios
      .post(url + ':3000/v1/user/create', data)
      .then(response => {
        const result = response.data;
        if (result.error == true) {
          this.notificationSystem.addNotification({
            title: <MdClear />,
            message: result.message,
            level: 'error',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          });
          return;
        }

        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'New user added successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        });
        this.setState({ userModal: false, user_id: '' });
        this.getUser();
      })
      .catch(error => {
        alert(error);
      });
  };

  render() {
    if (this.state.redirect) {
      return <Redirect to="/" />;
    }

    let { Role } = this.state;
    return (
      <>
        <NotificationSystem
          dismissible={false}
          ref={notificationSystem =>
            (this.notificationSystem = notificationSystem)
          }
          style={NOTIFICATION_SYSTEM_STYLE}
        />
        <Row>
          <Col md={4}>
            <Input
              className="ps-input-small"
              name="sortKey"
              value={this.state.sortKey}
              placeholder="Search"
              onChange={this.sortHandler}
            />
          </Col>
          {(Role === 'Superuser' ||
            Role === 'Admin' ||
            Role === 'Manager' ||
            Role === 'Supervisor' ||
            Role === 'Financial') && (
            <Col md={8}>
              <div className="text-right mb-3">
                <div className="ps-btn-group">
                  <Button color="link" onClick={this.toggle('ADD', null)}>
                    <IconContext.Provider value={{ color: '#2a2c6b' }}>
                      <BsPlusSquareFill size={25} />
                    </IconContext.Provider>
                  </Button>
                </div>
              </div>
            </Col>
          )}
        </Row>

        <Table className="tb-col-8 ps-responsive-table">
          <Thead>
            <Tr>
              <Th>Store Code</Th>
              <Th>Name</Th>
              <Th>Location</Th>
              <Th>Store Type</Th>
              <Th>Ecart Start Date</Th>
              <Th>Ecart End Date</Th>
              <Th>Timezone</Th>
              <Th>Action</Th>
            </Tr>
          </Thead>
          <Tbody>
            {this.state.filterList.length < 1 && (
              <tr>
                <td colSpan="8">
                  <div className="ps-empty-data">
                    <div className="empty-content">
                      <MdCreate />
                      <h4>No data to show</h4>
                      <span>Click the 'Create' button to add new store</span>
                    </div>
                  </div>
                </td>
              </tr>
            )}

            {this.state.filterList.length > 0 &&
              this.state.filterList
                .sort((a, b) => b.fav - a.fav)
                .map((item, index) => {
                  return (
                    <Tr key={index}>
                      <Td>{item.store_code}</Td>
                      <Td>{item.name}</Td>
                      <Td>{item.location}</Td>
                      <Td>{item.store_type}</Td>
                      <Td>{item.ecart_opendate}</Td>
                      <Td>{item.ecart_closedate}</Td>
                      <Td>{item.timezone}</Td>
                      <Td>
                        <div className="ps-action-button">
                          <Button
                            className="theme-button theme-button-secondary"
                            onClick={() => this.props.store(item.store_id)}
                          >
                            View
                          </Button>
                        </div>
                      </Td>
                    </Tr>
                  );
                })}
          </Tbody>
        </Table>
        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle()}
          className={this.props.className}
          centered
        >
          <PosStoreForm
            history={this.props.history}
            onToggleModal={this.toggle}
            closeModal={this.closeModal}
            match={this.props.match}
            data={this.state}
          />
        </Modal>

        <Modal
          isOpen={this.state.userModal}
          toggle={this.toggle()}
          className={this.props.className}
          centered
        >
          <Form onSubmit={this.addUser} className="AuthForm">
            <ModalHeader toggle={this.toggle()}>User Information</ModalHeader>
            <ModalBody>
              <Row>
                <Col md={12}>
                  <FormGroup>
                    <Label for="name">
                      User ID{' '}
                      <span className={'ps-indicator off'}>
                        User ID cannot be change after creation
                      </span>
                    </Label>

                    <Input
                      type="text"
                      name="user_id"
                      value={this.state.user_id}
                      onChange={this.IDHandler}
                      required
                    />
                    {this.state.duplicateId && (
                      <span
                        style={{ float: 'right' }}
                        className={'ps-indicator off'}
                      >
                        Duplicate User ID!
                      </span>
                    )}
                  </FormGroup>
                  <FormGroup>
                    <Label for="email">Email</Label>
                    <Input
                      type="email"
                      name="email"
                      value={this.state.email}
                      onChange={this.changeHandler}
                      required
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label for="name">Name</Label>
                    <Input
                      type="text"
                      name="name"
                      value={this.state.name}
                      onChange={this.changeHandler}
                      required
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label for="role">Role</Label>
                    <Input
                      type="select"
                      name="profileId"
                      value={this.state.profileId}
                      onChange={this.changeHandler}
                      required
                    >
                      <option value=""></option>
                      {this.state.roleList.length > 0 &&
                        this.state.roleList.map((item, index) => {
                          return (
                            <option key={index} value={item.id}>
                              {item.name}
                            </option>
                          );
                        })}
                    </Input>
                  </FormGroup>
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter>
              <Button
                className="theme-button theme-button-secondary"
                onClick={this.toggle()}
              >
                Close
              </Button>
              <Button
                className="theme-button theme-button-primary"
                type="submit"
              >
                {this.state.isEdit ? 'Save' : 'Add'}
              </Button>{' '}
            </ModalFooter>
          </Form>
        </Modal>

        <Modal
          isOpen={this.state.confirmModal}
          toggle={this.toggleConfirmModal()}
          className={this.props.className}
          centered
          style={{ fontSize: '0.85rem' }}
        >
          <ModalHeader toggle={this.toggleConfirmModal()}>
            Delete Store
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col md={12}>
                <p>
                  Are you sure you want to delete {this.state.selectedData} ?
                </p>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button
              className="theme-button theme-button-secondary"
              onClick={this.toggleConfirmModal()}
            >
              No
            </Button>
            <Button
              className="theme-button theme-button-primary"
              onClick={() => this.delete()}
            >
              Yes
            </Button>
          </ModalFooter>
        </Modal>
      </>
    );
  }
}
export default PosStoreTable;
